// extracted by mini-css-extract-plugin
module.exports = {"Container":"CookiesModal_Container__227ID","Text":"CookiesModal_Text__33ygh","Close":"CookiesModal_Close__1eLTT"};